import { render } from "./ImageListView.vue?vue&type=template&id=2b3b8be0&scoped=true&ts=true"
import script from "./ImageListView.vue?vue&type=script&lang=ts"
export * from "./ImageListView.vue?vue&type=script&lang=ts"

import "./ImageListView.vue?vue&type=style&index=0&id=2b3b8be0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3b8be0"]])

export default __exports__